export function sortElements(a, b) {
    if (a.path.length < b.path.length) {
        return -1;
    }
    if (a.path.length > b.path.length) {
        return 1;
    }
    return -(+(a.sort < b.sort) - +(a.sort > b.sort));
}
const hasOwnProperty = Object.prototype.hasOwnProperty;
// TODO: We should provide the root element (path)
export function toTrees(elements) {
    const list = elements.sort(sortElements);
    const roots = list.filter((el) => el.path.length === 0);
    if (roots.length === 0) {
        return [];
    }
    const mapping = getMappedElements(list);
    list.forEach((el) => {
        const key = el.path.concat(el.id).join(".");
        const parentKey = el.path.join(".");
        if (hasOwnProperty.call(mapping, parentKey)) {
            if (!hasOwnProperty.call(mapping[parentKey], "props")) {
                mapping[parentKey].props = { children: [] };
            }
            if (!hasOwnProperty.call(mapping[parentKey].props, "children")) {
                mapping[parentKey].props.children = [];
            }
            mapping[parentKey].props.children.push(mapping[key]);
        }
    });
    return roots.map((el) => mapping[el.id]);
}
export function getMappedElements(list) {
    return list.reduce((acc, el) => {
        // TODO: Replace this with a proper deep-clone library
        acc[el.path.concat(el.id).join(".")] = JSON.parse(JSON.stringify(el));
        return acc;
    }, {});
}
//# sourceMappingURL=tree.js.map